import React from 'react';
import { Link } from 'react-router-dom';
import { SERVICE_PILLARS } from '../../data/servicePillars';
import './ServicesSection.css';

const ServicesSection = ({ darkMode }) => {
  return (
    <section className={`services-section ${darkMode ? 'dark' : 'light'}`}>
      <div className="services-content">
        <div className="services-header">
          <h2 className="services-title">Líneas de servicio</h2>
          <p className="services-subtitle">
            Producto, seguridad, IA que se puede operar, web conectada, cloud
            y un ingeniero a cuota para pymes sin equipo de desarrollo.
          </p>
        </div>

        <div className="services-grid services-grid-pilares">
          {SERVICE_PILLARS.map((service) => (
            <Link key={service.id} to={service.href} className="service-card">
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.short}</p>
              <div className="service-features">
                {service.features.map((feature) => (
                  <span key={feature} className="feature-badge">
                    {feature}
                  </span>
                ))}
              </div>
            </Link>
          ))}
        </div>

        <div className="services-footer">
          <div className="services-footer-links">
            <Link to="/servicios" className="view-all-services">
              Ver el detalle de cada pilar →
            </Link>
            <Link to="/tercer-sector" className="view-all-services secondary">
              Tercer sector (ONG) →
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
